(function () {
  'use strict';

  if (customElements.get('zoom-images')) return;

  var ZOOM_SELECTOR = '[data-zoom-wrapper]';
  var GALLERY_SELECTOR = '[data-product-single-media-group]';
  var SLIDER_SELECTOR = '[data-product-single-media-slider]';
  var SLIDE_SELECTOR = '[data-product-single-media-wrapper]';
  var MOBILE = window.matchMedia('(max-width: 767px)');

  function setMobileArrowIcons(visible) {
    var icons = document.querySelectorAll('.lounelle-pswp-arrow-icon');
    Array.prototype.forEach.call(icons, function (icon) {
      icon.style.display = visible ? 'block' : 'none';
    });
  }

  customElements.define('zoom-images', class extends HTMLElement {
    constructor() {
      super();
      this.gallery = null;
      this.slider = null;
      this.links = [];
      this.handlers = new Map();
    }

    connectedCallback() {
      this.gallery = this.closest(GALLERY_SELECTOR);
      if (!this.gallery) return;

      this.slider = this.gallery.querySelector(SLIDER_SELECTOR);
      this.links = Array.prototype.slice.call(this.gallery.querySelectorAll(ZOOM_SELECTOR));

      this.links.forEach(function (link, index) {
        var handler = function (event) {
          event.preventDefault();

          if (this.slider && this.slider.classList.contains('is-moving')) return;
          if (window.theme && window.theme.a11y && window.theme.a11y.state) {
            window.theme.a11y.state.trigger = link;
          }

          this.open(index);
        }.bind(this);

        link.addEventListener('click', handler);
        this.handlers.set(link, handler);
      }, this);
    }

    disconnectedCallback() {
      this.handlers.forEach(function (handler, link) {
        link.removeEventListener('click', handler);
      });
      this.handlers.clear();
    }

    createItems() {
      return this.links.map(function (link) {
        var slide = link.closest(SLIDE_SELECTOR);
        var image = slide && slide.querySelector('img');
        var src = link.getAttribute('href');

        return {
          src: src,
          w: parseInt(link.getAttribute('data-image-width'), 10),
          h: parseInt(link.getAttribute('data-image-height'), 10),
          msrc: image ? (image.currentSrc || image.src || src) : src
        };
      }).filter(function (item) {
        return item.src && item.w && item.h;
      });
    }

    open(index) {
      if (!window.theme || !window.theme.LoadPhotoswipe) return;

      var items = this.createItems();
      if (!items.length) return;

      var safeIndex = Math.max(0, Math.min(index, items.length - 1));
      var mainClass = 'pswp-zoom-gallery';
      if (items.length === 1) mainClass += ' pswp-zoom-gallery--single';

      var options = {
        barsSize: { top: 60, bottom: 60 },
        history: false,
        focus: false,
        index: safeIndex,
        mainClass: mainClass,
        showHideOpacity: true,
        showAnimationDuration: 250,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['caption-close'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false
      };

      var mobileProductZoom = MOBILE.matches && document.body.classList.contains('template-product');

      if (mobileProductZoom) {
        options.barsSize = { top: 0, bottom: 0 };
        options.mainClass = mainClass + ' pswp--lounelle-mobile';
        options.showAnimationDuration = 160;
        options.hideAnimationDuration = 160;

        /*
         * Keep PhotoSwipe's native pinch/pan engine in control on touch devices.
         * Vertical-drag and pinch-to-close are disabled so the same gestures are
         * never repurposed while the customer is changing zoom level or panning.
         */
        options.closeOnVerticalDrag = false;
        options.pinchToClose = false;
        options.tapToToggleControls = false;
        options.timeToIdle = false;
        options.timeToIdleOutside = false;
        options.shareEl = false;
        options.fullscreenEl = false;
        options.zoomEl = false;
        options.counterEl = true;
        options.arrowEl = items.length > 1;
        options.preloaderEl = true;
        options.loop = items.length > 1;
        options.spacing = 0.035;

        /*
         * When zoomed, a one-finger drag pans the image instead of handing the
         * gesture to slide navigation. Once back at the fitted zoom level,
         * normal gallery navigation remains available.
         */
        options.allowPanToNext = false;
        options.maxSpreadZoom = 2.5;
        options.getDoubleTapZoom = function (isMouseClick, item) {
          var initial = item.initialZoomLevel || item.fitRatio || 1;
          if (isMouseClick) return Math.min(1, 2.5);
          return Math.min(Math.max(initial * 2.4, 1), 2.5);
        };
      }

      setMobileArrowIcons(mobileProductZoom);
      new window.theme.LoadPhotoswipe(items, options);
    }
  });
})();
